import '../../../plugins/polyfills/js/NodeList/forEach';

// TODO: Needs refactror in LIT-472988
(function (UX) {
    const holdings = {
        holdingsForm: null,
        sendToRadioGroup: null,
        emailsListInput: null,
        submitButton: null,
        emailsListRadio: null,
        init() {
            this.holdingsForm = document.querySelector('#holdingsForm');
            this.sendToRadioGroup = this.holdingsForm.querySelector('.sendTo');
            this.emailsListRadio = this.sendToRadioGroup.querySelector('#list');
            this.emailsListInput = this.holdingsForm.querySelector('#emailList');
            this.submitButton = this.holdingsForm.querySelector('.submit button');

            this.controller();
        },
        controller() {
            this.emailsListInput.addEventListener('input', () => {
                this.selectEmailsRadio();
                this.validateEmails();
            });
            this.sendToRadioGroup.addEventListener('change', () => {
                this.submitButton.disabled = !!this.emailsListRadio.checked;
                if (this.emailsListRadio.checked && this.emailsListInput.value !== '') this.validateEmails();
            });
            this.holdingsForm.addEventListener('submit', e => {
                if (window['validateHoldingsForm']) window.validateHoldingsForm(e);
            });
        },
        selectEmailsRadio() {
            if (this.emailsListInput.value !== '') {
                this.emailsListRadio.checked = true;
            }
        },
        validateEmails() {
            const error = this.holdingsForm.querySelector('.emailsList-error');
            this.emailsListInput.classList.remove('invalid');
            error.classList.add('hidden');
            this.submitButton.disabled = false;

            /** @var {array} */
            const emails = this.emailsListInput.value.split(';');
            let valid = true;
            if (emails.length > 0) {
                for (let i = 0; i < emails.length; i++) {
                    // set valid value and check if it false in the same line
                    if (!(valid = this.validateEmail(emails[i].trim()))) break;
                }
                if (!valid) {
                    this.emailsListInput.classList.add('invalid');
                    error.classList.remove('hidden');
                    this.submitButton.disabled = true;
                }
            }
        },
        validateEmail(email) {
            /*eslint-disable*/
            const re =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            /*eslint-enable*/
            return re.test(String(email).toLowerCase());
        },
    };

    UX.holdings = holdings;
})(UX);
